/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { Button, Form, Input, InputNumber, message, Modal, Radio } from "antd";
import React, { useCallback } from "react";
import { useFormatMessage } from "src/hooks";
import messageIds from "src/locales/messageIds";
import { AiServiceClient } from "src/services/AIPlatformService";

export default React.memo(function CreateService(props: {
  isModalShow: boolean;
  onShow: () => void;
  list: () => void;
}) {
  const { isModalShow, onShow, list } = props;
  const formatMessage = useFormatMessage();

  const [form] = Form.useForm();

  const onCancel = useCallback(() => {
    if (isModalShow) {
      onShow();
      form.resetFields();
    }
  }, [form, isModalShow, onShow]);

  const onCreate = useCallback(async () => {
    const formContent = await form.validateFields();
    AiServiceClient.createService(formContent).then((res) => {
      if (res.data?.success) {
        message.success(formatMessage(messageIds.common.createSuccessfully));
      } else {
        message.error(formatMessage(messageIds.common.createFailed));
      }
      list();
    });
    onCancel();
  }, [form, formatMessage, list, onCancel]);

  return (
    <Modal
      title={formatMessage(messageIds.common.create)}
      visible={isModalShow}
      footer={""}
      onCancel={onCancel}
      css={css`
        .ant-modal-content {
          width: 32vw;
        }
        .ant-modal-header {
          border-bottom: none;
        }
      `}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          label={formatMessage(messageIds.aiManage.serviceManagement.name)}
          name="name"
        >
          <Input
            placeholder={formatMessage(messageIds.common.placeholder)}
          ></Input>
        </Form.Item>
        <Form.Item
          label={formatMessage(messageIds.aiManage.serviceManagement.aliasName)}
          name="aliasName"
        >
          <Input
            placeholder={formatMessage(messageIds.common.placeholder)}
          ></Input>
        </Form.Item>
        <Form.Item
          label={formatMessage(
            messageIds.aiManage.serviceManagement.aihubServiceName
          )}
          name="aiHubServiceName"
        >
          <Input
            placeholder={formatMessage(messageIds.common.placeholder)}
          ></Input>
        </Form.Item>
        <Form.Item
          label={formatMessage(messageIds.aiManage.serviceManagement.version)}
          name="version"
        >
          <Input
            placeholder={formatMessage(messageIds.common.placeholder)}
          ></Input>
        </Form.Item>
        <Form.Item
          label={formatMessage(
            messageIds.aiManage.serviceManagement.trialLimited
          )}
          name="trialLimited"
        >
          <InputNumber
            controls={true}
            placeholder={`${formatMessage(
              messageIds.common.minimum
            )}: 0, ${formatMessage(messageIds.common.maximum)}: 9999999`}
            min={0}
            max={9999999}
            css={css`
              width: 100%;
            `}
          ></InputNumber>
        </Form.Item>
        <Form.Item
          label={formatMessage(messageIds.aiManage.serviceManagement.status)}
          name="status"
          initialValue={1}
        >
          <Radio.Group>
            <Radio value={1}>
              {formatMessage(messageIds.aiManage.userManagment.enable)}
            </Radio>
            <Radio value={0}>
              {formatMessage(messageIds.aiManage.userManagment.disable)}
            </Radio>
          </Radio.Group>
        </Form.Item>
      </Form>
      <div
        css={css`
          text-align: right;
          padding-top: 16px;
          padding-bottom: 16px;
        `}
      >
        <Button
          css={css`
            margin-right: 16px;
          `}
          onClick={onCancel}
        >
          {formatMessage(messageIds.common.cancel)}
        </Button>
        <Button type="primary" onClick={onCreate}>
          {formatMessage(messageIds.common.create)}
        </Button>
      </div>
    </Modal>
  );
});
